import { render } from "./ChoosePositionProperies.vue?vue&type=template&id=2d23d18a&scoped=true"
import script from "./ChoosePositionProperies.vue?vue&type=script&lang=js"
export * from "./ChoosePositionProperies.vue?vue&type=script&lang=js"

import "./ChoosePositionProperies.vue?vue&type=style&index=0&id=2d23d18a&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23d18a"]])

export default __exports__